import React, { useEffect, useState } from "react";
import ProductCard from "@/components/global/ProductCard";
import useCustomInfiniteHits from "@/hooks/search/useCustomInfiniteHits";
import { useInstantSearch } from "react-instantsearch";
// import SideMenu from "@/components/category/SideMenu";
// import ResponsiveButton from "@/components/category/ResponsiveButton";
import useCustomRefinementList from "@/hooks/search/useCustomRefinementList";
// import ResponsiveButton from "@/components/category/ResponsiveButton";
import SideMenu from "@/components/category/SideMenu";
import { useTranslation } from "next-i18next";
import useClearFacet from "@/hooks/search/useClearFacet";
import EmptyComp from "@/components/global/EmptyComp";
import BreadCrumb from "@/components/global/BreadCrumb";
import Spinner from "@/components/icons/Spinner";
import EmptySearchIcon from "@/components/icons/EmptySearchIcon";
import { useRouter } from "next/router";
import { event_search_result_item_list } from "@/utils/gtm";

function CustomInfiniteHits({ inputValue }) {
  const { hits } = useCustomInfiniteHits();
  const { status } = useInstantSearch();
  const isSearchStalled = status === "loading";
  const [selectedFilterKeys, setSelectedFilterKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    isSearchStalled
      ? setTimeout(() => setLoading(true), 100)
      : setTimeout(() => setLoading(false), 1000);
  }, [isSearchStalled]);

  const { t } = useTranslation("common");
  const {
    items,
    // hasExhaustiveItems,
    // createURL,
    refine,
    // sendEvent,
    // searchForItems,
    // isFromSearch,
    // canRefine,
    // canToggleShowMore,
    // isShowingMore,
    // toggleShowMore,
  } = useCustomRefinementList({
    attribute: "categories.level0",
    operator: "and",
    // attribute:"categories.level1",
    // attribute:"categories.level2",
    // attribute:"categories.level3",
  });
  const clearFacet = useClearFacet({ attributes: ["categories.level0"] });

  const handleFilter = ({ item, code }) => {
    // for fill or empty the check box
    if (selectedFilterKeys?.includes(`${code}=${item?.Key}`)) {
      const updatedSelectedFilterKeys = selectedFilterKeys?.filter(
        (itemF) => itemF != `${code}=${item?.Key}`
      );
      setSelectedFilterKeys(updatedSelectedFilterKeys);
    } else {
      setSelectedFilterKeys((prev) => [...prev, `${code}=${item?.Key}`]);
    }

    // make a filter
    refine(item?.Key);
  };

  console.log("hits", hits);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (hits.length > 0 && inputValue && status !== "loading") {
        event_search_result_item_list(inputValue, hits?.length);
      }
    }, 800);

    return () => clearTimeout(debounceTimeout);
  }, [hits, inputValue, status]);

  const { locale } = useRouter();
  const BreadCrumbItems = [
    {
      name: locale == "en" ? "Search" : "البحث",
      url: "/search",
      active: true,
      key: "search",
    },
  ];

  return hits?.length ? (
    <>
      <BreadCrumb items={BreadCrumbItems} />
      <div className="grid w-11/12 grid-cols-12 gap-5 mx-auto my-4 sm:my-8">
        <SideMenu
          {...{
            selectedFilterKeys,
            setSelectedFilterKeys,
            fromSearch: items?.map((item) => ({
              ...item,
              parentName: "sections",
            })),
            handleFilter,
            handleResetFilter: clearFacet,
            t,
          }}
        />
        <div className="col-span-full lg:col-span-9 *:mb-5">
          {/* Hide These Components when clicking to any option in side menu */}
          {/* <ResponsiveButton
            {...{
              setSelectedFilterKeys,
              selectedFilterKeys,
              fromSearch: items?.map((item) => ({
                ...item,
                parentName: "sections",
              })),
              handleFilter,
              handleResetFilter: clearFacet,
              isSearching: true,
              t,
            }}
          /> */}
          <div className="mx-auto grid grid-cols-2 min-[420px]:grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {hits?.map((hit) => (
              <ProductCard hit={hit} key={hit.objectID} />
            ))}
          </div>
          <div id="afterProductsSection" className="w-full"></div>
        </div>
      </div>
    </>
  ) : loading ? (
    <div className="w-11/12 mx-auto my-10 text-lg min-h-[70vh] flex flex-col text-slate-800 items-center justify-center gap-4">
      <Spinner width={100} />
      <span className="uppercase text-md">Searching…</span>
    </div>
  ) : (
    <EmptyComp
      {...{
        title: t("empty search results!"),
        description: t("try another keyword!"),
        icon: <EmptySearchIcon className="size-80 max-sm:size-60" />,
      }}
    />
  );
}

export default CustomInfiniteHits;
